Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-cond-assign */
/* eslint-disable no-sequences */
var lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz',
    uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    numbers = '0123456789',
    badWords = ['qwerty', 'abc123', '123abc', 'welcome', 'password', 'jesus', 'abc', 'test'];

var PasswordStrengthTest = function () {
  function PasswordStrengthTest() {
    var _this = this;

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      badWords: [],
      minLength: 8,
      maxLength: 24
    };

    _classCallCheck(this, PasswordStrengthTest);

    this.correctLength = function (value) {
      return value.length >= _this.minLength && value.length <= _this.maxLength;
    };

    this.hasJunk = function (value) {
      var lowerValue = value.toLowerCase();
      for (var i = 0; i < badWords.length; i += 1) {
        if (lowerValue.indexOf(badWords[i]) > -1) return 1;
      }
      return 0;
    };

    this.repeatedCharacters = function (value) {
      return value.match(/([a-zA-Z0-9])\1{1,}/g);
    };

    this.passwordStrength = function (value) {
      var i = value.length;
      var currentIndex = 0,
          subString = '',
          duplicateCount = 0,
          strengthValue = 0;

      if (i >= 6 && i <= 24) {
        value.match(/^[a-zA-Z]+$/) || value.match(/^\d+$/) ? strengthValue = -39 : i < 11 ? strengthValue = 5 : i >= 11 && i <= 14 ? strengthValue = 15 : i > 14 && (strengthValue = 25);
        for (currentIndex = 0; currentIndex < i; currentIndex += 1) {
          if (subString = '' + String(value.substring(currentIndex, currentIndex + 1)), lowercaseLetters.indexOf(subString) >= 0) {
            strengthValue += 5, !0;
            break;
          }
        }

        for (currentIndex = 0; currentIndex < i; currentIndex += 1) {
          if (subString = '' + String(value.substring(currentIndex, currentIndex + 1)), uppercaseLetters.indexOf(subString) >= 0) {
            strengthValue += 5, !0;
            break;
          }
        }

        for (currentIndex = 0; currentIndex < i; currentIndex += 1) {
          if (subString = '' + String(value.substring(currentIndex, currentIndex + 1)), numbers.indexOf(subString) >= 0) {
            strengthValue += 5, !0;
            break;
          }
        }

        for (duplicateCount = 0, currentIndex = 0; currentIndex < i; currentIndex += 1) {
          if (subString = '' + String(value.substring(currentIndex, currentIndex + 1)), lowercaseLetters.indexOf(subString) >= 0 || uppercaseLetters.indexOf(subString) >= 0) {
            duplicateCount += 1;
          } else {
            if (duplicateCount > 3) break;
            duplicateCount = 0;
          }
        }

        duplicateCount < 4 && (strengthValue += 10, !0);

        for (duplicateCount = 0, currentIndex = 0; currentIndex < i; currentIndex += 1) {
          if (subString = '' + String(value.substring(currentIndex, currentIndex + 1)), numbers.indexOf(subString) >= 0) {
            duplicateCount += 1;
          } else {
            if (duplicateCount > 3) break;
            duplicateCount = 0;
          }
        }

        for (duplicateCount < 4 && (strengthValue += 10, !0), currentIndex = 0; currentIndex < i; currentIndex += 1) {
          if (subString = '' + String(value.substring(currentIndex, currentIndex + 1)), !(lowercaseLetters.indexOf(subString) >= 0 || uppercaseLetters.indexOf(subString) >= 0 || numbers.indexOf(subString) >= 0)) {
            strengthValue += 5;
            break;
          }
        }
        var characters = {};
        for (currentIndex = 0; currentIndex < i; currentIndex += 1) {
          var k = value.charAt(currentIndex);
          !0 !== characters[k] && (strengthValue += 2, characters[k] = !0);
        }
      }
      return strengthValue;
    };

    this.validate = function (value) {
      if (_this.isNull(value) || _this.repeatedCharacters(value) || !_this.correctLength(value) || _this.hasJunk(value)) {
        return 0;
      }
      return _this.passwordStrength(value);
    };

    this.badWords = badWords.concat(props.badWords || []);
    this.minLength = props.minLength || 8;
    this.maxLength = props.maxLength || 25;
  }

  _createClass(PasswordStrengthTest, [{
    key: 'isNull',
    value: function () {
      function isNull(value) {
        return value === null && value === '';
      }

      return isNull;
    }()
  }]);

  return PasswordStrengthTest;
}();

/* eslint-enable no-unused-expressions */
/* eslint-enable no-nested-ternary */
/* eslint-enable no-cond-assign */
/* eslint-enable no-sequences */


exports['default'] = PasswordStrengthTest;
